var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rp"},[_c('div',{staticClass:"rp-title"},[_vm._v("Report preview")]),_c('img',{attrs:{"src":require("@/assets/report-preview.png"),"alt":"Report preview","width":"824"}})])
}]

export { render, staticRenderFns }